<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div v-if="goods.id">

        <div style="padding-bottom: 50px;">
            <van-image :src="baseCdnUrl+'/api/public/goods_'+goods.id+'.jpg'"/>
            <div style="background: white; padding: 10px;">
                <div style="font-size: 16px;margin-bottom: 10px;font-weight: 500;">{{goods.name}}</div>
                <van-row>
                    <van-col span="18" style="color: var(--color);">
                        <span>￥</span>
                        <span style="font-size: 20px; font-weight: 600;">{{ goods.priceString }}</span>
                        <span v-if="goods.priceInCent !== goods.priceOriginal" style="font-size: 16px; font-weight: 600; margin-left: 6px; text-decoration: line-through; color:#969799;">￥{{ (goods.priceOriginal / 100).toFixed(2) }}</span>
                    </van-col>
                    <van-col span="6" style="text-align: right;">{{ goods.orderCnt }}件已购</van-col>
                </van-row>
            </div>
            <van-notice-bar v-if="goods.coupon && goods.coupon.time>0" wrapable left-icon="fire-o"
                            :scrollable="false">
                <template #default>
                    <div>
                        专属<span style="font-weight: 600;font-size: 20px;">{{goods.coupon.discountDesc}}</span>{{ goods.coupon.discountDesc2 }}，限时价：<span>￥</span><span style="font-size: 20px; font-weight: 600;">{{goods.priceDesc2}}</span>
                        <div v-if="goods.coupon.time<2592000000">
                            优惠剩余时间：<van-count-down style="display: inline-block;color: #ED6A0C;font-weight: 600; font-size: 16px;" :time="goods.coupon.time" />
                        </div>
                    </div>
                </template>
            </van-notice-bar>

            <div class="goods-intro" v-html="goods.intro"></div>
<!--            <van-tabs v-model="activeTab" color="var(--color)" style="margin-top: 10px;">-->
<!--                <van-tab title="产品介绍">-->
<!--                    <div class="goods-intro" v-html="goods.intro"></div>-->
<!--                </van-tab>-->
<!--                <van-tab title="产品推荐"></van-tab>-->
<!--            </van-tabs>-->
        </div>

        <Draggable :distanceRight='0' :distanceBottom='200' :isScrollHidden='false' :isCanDraggable='true' style="padding-right: 4px;">
            <div v-if="!quickButtonShow" @click="quickButtonShow=true;" style="background: var(--color);width: 50px; height:50px;border-radius: 25px;color:white;text-align: center;display: flex;justify-content: center;align-items: center;">
                快速<br/>导航
            </div>
            <div v-if="quickButtonShow" style="background: white; width:50px; text-align: center; border-radius: 25px;box-shadow: 0 2px 6px 0 rgb(146 146 146);">
                <van-icon @click="quickButtonShow=false;" name="arrow-down" size="28" color="#B5B5B5"></van-icon>
                <van-divider style="margin: 0 0 10px 0;"></van-divider>
                <span @click="$router.push('/')" style="color: var(--color);">首页</span>
                <van-divider style="margin: 10px 0;"></van-divider>
                <span @click="$router.push('/products')" style="color: var(--color);">套餐</span>
                <van-divider style="margin: 10px 0;"></van-divider>
                <span @click="$router.push('/my_center')" style="color: var(--color);">个人<br/>中心</span>
                <van-divider style="margin: 10px 0;"></van-divider>
            </div>
        </Draggable>

        <van-goods-action>
            <van-goods-action-icon icon="chat-o" text="客服" @click="serviceOnlineClicked" />
            <van-goods-action-button
                color="var(--color)"
                type="danger"
                text="立即购买"
                @click="buyClicked"
            />
        </van-goods-action>

    </div>
</template>

<script>
import http, {BASE_URL, BASE_CDN_URL, SERVICE_TEL} from "@/utils/http";
import qs from "qs";
import {Dialog} from "vant";
import Draggable from "../components/Draggable";
import moment from "moment";

export default {
    name: "Goods",
    components: {
        Draggable
    },
    data() {
        return {
            baseUrl: BASE_URL,
            baseCdnUrl: BASE_CDN_URL,
            refreshing: false,
            loading: false,
            finished: false,
            couponCode: '',
            keywords: '',
            goods: {name: '', id: 0},
            list: [],

            show1: false,
            show2: false,
            activeTab: 0,

            quickButtonShow: false,
        };
    },
    created() {
        var channel = this.$route.query.ch?this.$route.query.ch:'';
        if(channel){
            localStorage.setItem("channel", channel);
            console.log('goods storage ch: '+channel)
        }

        this.goods.id = this.$route.query.id?this.$route.query.id:'';
        var couponCode = this.$route.query.c?this.$route.query.c:'';
        if(!this.goods.id) {
            this.$router.replace("/");
            return;
        }
        if(couponCode) {
            localStorage.setItem("couponCode", couponCode);
            this.couponCode = couponCode;
        } else {
            localStorage.removeItem("couponCode");
            this.couponCode = '';
        }
        this.loadDetail(this.goods.id, (goods) => {
            if(goods.coupon) {
                goods.coupon.time = moment(goods.coupon.validTo).valueOf() - moment().valueOf();
                goods.coupon.discountDesc = goods.coupon.discount % 10 === 0 ? goods.coupon.discount / 10 : goods.coupon.discount;
                if(goods.coupon.minus > 0) {
                    goods.coupon.discountDesc = (goods.coupon.minus / 100).toFixed(2);
                }
                goods.coupon.discountDesc2 = goods.coupon.minus>0?'元立减券':'折折扣券';
                goods.priceDesc2 = goods.coupon.minus>0?((goods.priceInCent>goods.coupon.minus?(goods.priceInCent-goods.coupon.minus):0)/100).toFixed(2):(goods.priceInCent * goods.coupon.discount / 10000).toFixed(2);
            }
            this.goods = goods;
            // console.log(this.goods)
        });
    },
    methods: {
        loadDetail(goodsId, callback) {
            let payload = qs.stringify({id: goodsId, couponCode: this.couponCode});
            http.post('/api/public/goods_detail', payload).then(res => {
                if(callback){
                    var goods = res.data.extra.goods;
                    // console.log(goods)
                    if(goods.intro) {
                        // /api/goods/ue/image换成 baseurl/api/goods/ue/image/
                        goods.intro = goods.intro.replace(/\/api\/product\/ue\/image\//g, this.baseCdnUrl + '/api/product/ue/image/');
                    }
                    if(goods.goodsSpecs && goods.goodsSpecs.length > 0) {
                        goods.priceString = (goods.goodsSpecs[0].priceInCent / 100).toFixed(2);
                    } else {
                        goods.priceString = '';
                    }
                    callback(goods);
                }
                // console.log(res)
            });
        },
        serviceOnlineClicked: function () {
            Dialog.confirm({
                confirmButtonColor: '#b28303',
                confirmButtonText:'拨打',
                message: '<div style="font-size: 16px;">拨打'+SERVICE_TEL+'客服电话</div><div style="color:#A1A1A1;margin-top: 10px;">服务时间：工作日9:30-17:30</div>',
            }).then(() => {
                window.open("tel:"+SERVICE_TEL,'_self');
            })
        },
        buyClicked: function() {
            // this.$router.push('/goods_order?id='+this.goods.id+'&oid=123');
            window.location.href = this.goods.orderUrl;
        }
    },
}
</script>

<style scoped lang="less">
    /deep/.goods-intro img:not([width]) {
        width: 100%;
    }
</style>